import React from 'react';
import { useIntl } from 'react-intl';
import { MdOutlineAutoAwesome } from 'react-icons/md';
import { CreateFace, CreateHint, CreateIcon, CreateRoot, CreateTitle } from './FooterTile.styled';

const FooterCreateTile: React.FC<{ readonly onCreate: () => void }> = ({ onCreate }) => {
  const intl = useIntl();
  return (
    <CreateRoot>
      <CreateFace type="button" onClick={onCreate} data-testid="apps-footer__create">
        <CreateIcon aria-hidden="true">
          <MdOutlineAutoAwesome size={24} />
        </CreateIcon>
        <CreateTitle>
          {intl.formatMessage({ id: 'apps.builder.create.title', defaultMessage: 'Create your app' })}
        </CreateTitle>
        <CreateHint>
          {intl.formatMessage({ id: 'appsFooter.create.hint', defaultMessage: 'With the assistant' })}
        </CreateHint>
      </CreateFace>
    </CreateRoot>
  );
};

export default FooterCreateTile;
